/**
 * SDK version.
 */
export const VERSION = "2.4.8";
